import { render, staticRenderFns } from "./LeadPartnersManagement.vue?vue&type=template&id=2e8ef610&scoped=true&"
import script from "./LeadPartnersManagement.vue?vue&type=script&lang=js&"
export * from "./LeadPartnersManagement.vue?vue&type=script&lang=js&"
import style0 from "./LeadPartnersManagement.vue?vue&type=style&index=0&id=2e8ef610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ef610",
  null
  
)

export default component.exports